import { useQuery } from '@tanstack/react-query';

import fetch from './fetch';
import { transformResponseData } from './adapter';

function useBankAccountChangeRequest() {
  const { cb, key } = fetch();

  const { data: rawData, isLoading, isSuccess, isError, refetch } = useQuery(key, cb);

  const data = transformResponseData(rawData);

  const isProcessing = data?.is_processing === true;
  const isInProgress = data?.status === 'IN_PROGRESS';
  const isCancelled = data?.status === 'CANCELLED';
  const isApproved = data?.status === 'APPROVED';
  const isRejected = data?.status === 'REJECTED';
  const isUpdated = data?.status === 'UPDATED';

  return {
    data,
    isLoading,
    isSuccess,
    isError,
    refetch,
    isProcessing,
    isInProgress,
    isApproved,
    isRejected,
    isUpdated,
    isCancelled,
  };
}

export default useBankAccountChangeRequest;
